import styled, { css } from "styled-components";

import { AuthModalHeaderLogoContainer } from "../AuthModal/components/atoms/AuthModalHeaderLogo/styles";
import {
  AuthenticationModalContainer,
  AuthenticationModalContent,
} from "../AuthModal/components/organisms/AuthenticationModal/styles";
import { ForgotPasswordContainer } from "../AuthModal/components/templates/ForgotPassword/styles";
import { InitialAuthModalContainer } from "../AuthModal/components/templates/Initial/styles";
import { LoginComponentContainer } from "../AuthModal/components/templates/Login/components/LoginComponent/styles";
import { AuthModalRegisterForm } from "../AuthModal/components/templates/Register/components/RegisterForm/styles";

interface IExclusivePageContainerProps {
  isPlatformIsPrivate: boolean;
}
export const ExclusivePageContainer = styled.div<IExclusivePageContainerProps>`
  position: relative;
  height: 100%;
  width: 100%;

  padding: 4rem 1rem 0 1rem;

  display: grid;
  place-items: center;

  .exclusive-page-background-image {
    object-fit: cover;

    position: absolute;
    top: 0;
    left: 0;
  }

  ${AuthenticationModalContainer} {
    pointer-events: none;

    z-index: 96;

    height: min-content;
    width: min-content;

    background-color: ${({ theme }) => theme.authModal.backgroundColor};
    border: 0.5px solid ${({ theme }) => theme.authModal.borderColor};

    position: relative;

    border-radius: 1rem;

    padding: 0;

    @media screen and (min-width: 768px) {
      height: calc(100vh - 4rem);
      width: 100vw;

      position: absolute;

      border-radius: 0;

      max-width: 600px;

      left: unset;
      top: unset;

      right: 0;
      bottom: 0;

      padding-right: 0.75rem;
      overflow-y: auto;

      ::-webkit-scrollbar {
        width: 2px;
        display: block;
      }

      ::-webkit-scrollbar-track {
        width: 2px;
        display: block;
      }

      ::-webkit-scrollbar-thumb {
        width: 2px;
        display: block;
      }
    }
  }

  ${AuthenticationModalContent} {
    margin: 0;
    width: max-content;

    height: min-content;

    background-color: transparent;
    border: none;

    min-width: 300px;

    padding: 1.5rem;

    @media screen and (min-width: 768px) {
      width: inherit;
    }
  }

  ${({ isPlatformIsPrivate }) =>
    isPlatformIsPrivate &&
    css`
      [data-testid="close"] {
        display: none;
      }
    `}

  ${AuthModalHeaderLogoContainer} {
    display: none;

    @media screen and (min-width: 768px) {
      display: grid;
      place-items: center;
    }
  }

  ${LoginComponentContainer} {
    padding-bottom: 0;
  }

  ${InitialAuthModalContainer} {
    height: max-content;
    justify-content: center;
    align-items: center;
    padding: 0;
  }

  ${ForgotPasswordContainer} {
    padding: 0;
    height: min-content;
  }

  ${AuthModalRegisterForm} {
    max-height: unset;
  }
`;
